import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";

@Component({
  selector: 'app-delete-button',
  standalone: true,
  imports: [ MatButtonModule, IconModule ],
  templateUrl: './delete-button.component.html',
  styleUrl: './delete-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteButtonComponent {
  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  constructor () {
    this._faIconLibrary.addIcons(faTrashCan);
  }
}
